import { Component, ChangeDetectionStrategy, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../../core/services/auth.service';
import { User } from '../../../../core/models/auth.model';
import { ThemeToggleService, ThemeMode } from '../../../../partials/theme-toggle/theme-toggle.service';

@Component({
  selector: 'app-sidebar-account',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './sidebar-account.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarAccountComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  public themeService = inject(ThemeToggleService);

  user$ = this.authService.currentUser$;
  isUserPopupOpen = false;

  toggleUserPopup(event: Event): void {
    event.stopPropagation();
    this.isUserPopupOpen = !this.isUserPopupOpen;
    this.cdr.markForCheck();
  }

  closePopup(): void {
    this.isUserPopupOpen = false;
    this.cdr.markForCheck();
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  getInitials(user: User | null): string {
    if (!user) return 'VU';
    if (user.username) {
      return user.username.substring(0, 2).toUpperCase();
    }
    return user.email.substring(0, 2).toUpperCase();
  }

  setTheme(mode: ThemeMode): void {
    this.themeService.setThemeMode(mode);
    this.cdr.markForCheck();
  }
}
